import { NEW_DOCUMENT } from "../constants";
import modeEnum from "../mode";
import actionTypes from "./actionTypes";
import api from "./api";
export default {
    importPreview: (file, completed) => ({
        type: actionTypes.PREVIEW_IMPORT,
        payload: {
            promise: () => api.importPreview(file)
        },
        completed: (_, { payload }) => {
            completed(payload);
        },
        scope: `${actionTypes.PREVIEW_IMPORT}_${file.name}`
    }),
    saveDocument: (document, activeNewDocumentAfterCreation, fileAttach, importParams) => ({
        type: actionTypes.SAVE_DOCUMENT,
        payload: {
            promise: () => api.saveDocument(document, fileAttach, importParams)
        },
        meta: {
            activeNewDocumentAfterCreation,
            isNew: document.Id === NEW_DOCUMENT.Id
        },
        scope: `${actionTypes.SAVE_DOCUMENT}_${document.Id}`
    }),
    duplicateDocument: (document) => ({
        type: actionTypes.DUPLICATE_DOCUMENT,
        payload: {
            promise: () => api.duplicateDocument(document)
        },
        scope: `${actionTypes.DUPLICATE_DOCUMENT}_${document.Id}`
    }),
    setDraft: (draft) => ({
        type: actionTypes.SET_DRAFT,
        draft
    }),
    getDocument: (documentId) => ({
        type: actionTypes.GET_DOCUMENT,
        payload: {
            promise: () => api.getDocument(documentId)
        },
        scope: `${actionTypes.GET_DOCUMENT}_${documentId}`
    }),
    setCreateNewDocument: (projectId) => ({
        type: actionTypes.SET_MODE_AND_DOCUMENT_ID,
        mode: modeEnum.CREATE,
        projectId
    }),
    setEditDocument: (documentId) => ({
        type: actionTypes.SET_MODE_AND_DOCUMENT_ID,
        documentId,
        mode: modeEnum.EDIT
    }),
    setDuplicateDocument: (documentId) => ({
        type: actionTypes.SET_MODE_AND_DOCUMENT_ID,
        documentId,
        mode: modeEnum.DUPLICATE
    }),
    closeForm: () => ({
        type: actionTypes.SET_MODE_AND_DOCUMENT_ID,
        documentId: undefined
    }),
    getWorkSpaceProjects: (documentId, workSpaceId, completed) => ({
        type: actionTypes.GET_DOCUMENT,
        payload: {
            promise: () => api.getWorkSpaceProjects(workSpaceId)
        },
        scope: `${actionTypes.GET_WORKSPACE_PROJECTS}_${documentId}`,
        completed: (_, { payload }) => {
            completed && completed(payload);
        }
    })
};
